<section class="container">
  <!-- Title or Title Image -->
  <ng-container *ngIf="!titleImage?.length && title; else titleImageTemplate">
    <h2 class="title zoom-in" [style]="'fontSize.48' | translate">
      {{ title }}
    </h2>
  </ng-container>

  <ng-template #titleImageTemplate>
    <div class="image-container" *ngIf="titleImage">
      <img
        id="titleImg"
        class="image"
        [src]="titleImage"
        alt="content-image"
        loading="lazy"
        [style.--image-width]="imageWidth"
        (load)="onImageLoad($event)"
        (loadstart)="onImageLoadStart()"
        [ngClass]="{ loaded: isImageLoaded }"
      />
    </div>
  </ng-template>

  <!-- Tags -->
  <div class="tags zoom-in horizontal-center">
    <div class="horizontal-ac tags-wrapper">
      <ng-container
        *ngIf="contentDetailInfo?.contentTags?.includes('trending')"
      >
        <div
          class="custom-tags horizontal-ac"
          [style]="'fontSize.18' | translate"
        >
          {{ contentDetailInfo?.contentTags }}
        </div>
      </ng-container>

      <div
        *ngFor="
          let tag of contentDetailInfo?.customTags;
          let i = index;
          trackBy: trackByIndex
        "
        class="custom-tags horizontal-ac"
        [style.height]="'1.563vw'"
      >
        <ng-container *ngIf="tag.key === 'Premium'; else rentIcon">
          <app-icon icon="premium"></app-icon>
        </ng-container>
        <ng-template #rentIcon>
          <app-icon *ngIf="tag.key === 'Rent'" icon="rent"></app-icon>
        </ng-template>
        <span *ngIf="tag.value">{{ tag.value }}</span>
      </div>

      <ng-container *ngIf="contentDetailInfo?.is4k">
        <div
          class="uhd-tag horizontal-ac"
          [style]="'fontSize.18' | translate"
          [style.height]="'1.563vw'"
        >
          4K UHD
        </div>
      </ng-container>

      <ng-container *ngIf="contentDetailInfo?.isDolbyAudio">
        <div class="dolby-audio horizontal-ac" [style.height]="'1.563vw'">
          <app-icon icon="tag-dolby-audio"></app-icon>
        </div>
      </ng-container>

      <ng-container *ngIf="contentDetailInfo?.isAtmos">
        <div class="dolby-audio horizontal-ac" [style.height]="'1.563vw'">
          <app-icon icon="tag-dolby-atmos"></app-icon>
        </div>
      </ng-container>

      <!-- Dolby 5.1 -->
      <ng-container *ngIf="contentDetailInfo?.is51">
        <div class="dolby-51 horizontal-ac" [style.height]="'1.563vw'">
          <app-icon icon="tag-dolby-51"></app-icon>
        </div>
      </ng-container>
    </div>
  </div>

  <!-- Year & Rating -->
  <div class="year-rating-container zoom-in">
    <span
      class="year-tag"
      *ngIf="contentDetailInfo?.contentTags"
      [style]="'fontSize.24' | translate"
      >{{ contentDetailInfo?.contentTags }}</span
    >
    <span
      class="rating-tag"
      *ngIf="contentDetailInfo?.rating"
      [style]="'fontSize.18' | translate"
      >{{ contentDetailInfo?.rating }}</span
    >
  </div>

  <ng-container *ngIf="contentDetailInfo?.multiLingualAudio">
    <div class="multi-lingual-audio-container horizontal-ac zoom-item">
      <app-icon icon="tag-multi-lingual-audio"></app-icon>
      <span>{{ contentDetailInfo?.multiLingualAudio }}</span>
    </div>
  </ng-container>

  <!-- Genre -->
  <div
    class="genre-tag zoom-in"
    *ngIf="contentDetailInfo?.advisories"
    [style]="'fontSize.22' | translate"
  >
    <span class="genre-tag">{{ contentDetailInfo?.advisories }}</span>
  </div>

  <!-- Always show title for episodes below genre tag -->
  <ng-container
    *ngIf="
      allowedTitleTypes.includes(resource?.contentType) &&
      titleImage?.length &&
      title
    "
  >
    <h2
      class="episodes-title"
      [style]="'fontSize.28' | translate"
      style="margin-top: 0.521vw"
    >
      {{ title }}
    </h2>
  </ng-container>

  <!-- Description (only for non-hero layout) -->
  <h3
    class="description-content zoom-in"
    *ngIf="
      showDescription &&
      resource?.shortDescription &&
      resource?.shortDescription[lang]
    "
    [style]="'fontSize.24' | translate"
    [ngStyle]="{ '-webkit-line-clamp': maxLines, 'line-clamp': maxLines }"
  >
    {{ resource?.shortDescription[lang] }}
  </h3>
</section>
